import { create } from 'zustand';
import api from '../lib/api';

export interface PetConfig {
  id: string;
  folder: string;
  ext: string;
}

interface PetStore {
  petConfig: PetConfig[];
  isLoading: boolean;
  fetchPetConfig: () => Promise<void>;
}

export const usePetStore = create<PetStore>((set) => ({
  petConfig: [],
  isLoading: false,
  fetchPetConfig: async () => {
    set({ isLoading: true });
    try {
      const response = await api.get('/pets/config');
      set({ petConfig: response.data });
    } catch (error) {
      console.error('Failed to fetch pet config', error);
    } finally {
      set({ isLoading: false });
    }
  },
}));
